<template>
    <div>
        <Transition
            v-if="!requestSent"
            name="fade"
            mode="out-in"
        >
            <div
                class="DownloadData"
            >
                <PageTitle class="DownloadData-title">
                    {{ $t('personal-account.download-data.title') }}
                </PageTitle>
                <div class="DownloadData-globalContainer">
                    <div class="DownloadData-container">
                        <Block>
                            <p>
                                {{ $t('personal-account.download-data.description.1') }}
                            </p>
                            <p>
                                {{ $t('personal-account.download-data.description.2') }}
                            </p>
                            <InputPhoneNumber
                                v-if="profileLoaded"
                                v-model="phoneNumber"
                                :lang="phoneCountry"
                                data-cy="input.phoneNumber"
                                @update="updatePhone"
                            />
                            <p>
                                {{ $t('personal-account.download-data.description.3') }}
                            </p>
                            <RoundedButton
                                :disabled="!isValidPhoneNumber"
                                :inactive="!isValidPhoneNumber"
                                :label="$t('personal-account.download-data.submit')"
                                data-cy="button.downloadData"
                                type="reversed"
                                class="DownloadData-button"
                                @buttonClicked="sendRequest"
                            />
                        </Block>
                    </div>
                </div>
            </div>
        </Transition>
        <Transition
            v-if="requestSent"
            name="fade"
            mode="out-in"
        >
            <div
                class="DownloadData"
            >
                <PageTitle class="DownloadData-title">
                    {{ $t('personal-account.download-data.title') }}
                </PageTitle>
                <div class="DownloadData-globalContainer">
                    <div class="DownloadData-container">
                        <Block>
                            <p>
                                {{ $t('personal-account.download-data.requestSent.description') }}
                            </p>
                            <RoundedButton
                                :label="$t('personal-account.download-data.requestSent.goBack')"
                                data-cy="button.goBackSettings"
                                type="reversed"
                                class="DownloadData-button"
                                @buttonClicked="goBackSettings"
                            />
                        </Block>
                    </div>
                </div>
            </div>
        </Transition>
    </div>
</template>

<script>
import PageTitle from '@/components/PageTitle.vue';
import Transition from "@/components/Transition.vue";
import {
    Block, InputPhoneNumber, RoundedButton
} from '@free2move/vuejs-components';

import Vue from "vue";
import phone from "phone";
import _ from 'lodash';
import Component from "vue-class-component";
import {GET_PROFILE, SEND_DOWNLOAD_DATA_REQUEST} from "@/store/action-types";

@Component({
    components: {
        PageTitle,
        Transition,
        Block,
        InputPhoneNumber,
        RoundedButton
    },
})
export default class DownloadData extends Vue {
    data() {
        return {
            phoneNumber: "",
            formattedPhoneNumber: "",
            profileLoaded: false,
            phoneCountry : "",
            requestSent: false,
        }
    }

    get isValidPhoneNumber() {
        return phone(this.formattedPhoneNumber).isValid;
    }

    updatePhone(value) {
        this.formattedPhoneNumber = value.formattedNumber;
    }

    mounted() {
        this.$store.dispatch(GET_PROFILE, {
            callback: (response) => {
                if (response.data) {
                    this.phoneNumber = response.data.phoneNumber;
                    this.formattedPhoneNumber = response.data.phoneNumber;
                    this.phoneCountry = !_.isEmpty(this.phoneNumber) ? phone(this.phoneNumber).countryIso2 : this.$country;
                    this.profileLoaded = true;
                }
            }
        });
    }

    sendRequest() {
        this.$store.dispatch(SEND_DOWNLOAD_DATA_REQUEST, {
            callback: (response) => {
                if (!response.error) {
                    this.requestSent = true;
                }
            },
            data: {
                phoneNumber: this.formattedPhoneNumber
            }
        });
    }

    goBackSettings() {
        this.$router.push({ name: "personalAccountSettings" });
    }
}
</script>

<style lang="scss" scoped>
.DownloadData {
    width: 100%;

    @media (max-width: $f2m-desktop-breakpoint) {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        min-height: calc(100vh - 150px);
        position: relative;
    }


    &-container {
        flex-grow:1;
        margin-bottom: 56px;
        max-width: 495px;

        @media (max-width: $f2m-desktop-breakpoint) {
            max-width: 100%;
        }

    }

    &-globalContainer {
        display: flex;
        gap: 38px;

        @media (max-width: $f2m-desktop-breakpoint) {
            gap: 0;
        }
    }

    &-title {
        margin-bottom: 60px;
    }

    &-button{
        width: 100%;
    }
}
</style>
